import { render } from "./SubCategoryList.vue?vue&type=template&id=3cc95514&scoped=true"
import script from "./SubCategoryList.vue?vue&type=script&lang=js"
export * from "./SubCategoryList.vue?vue&type=script&lang=js"

import "./SubCategoryList.vue?vue&type=style&index=0&id=3cc95514&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc95514"]])

export default __exports__